var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"askai-frame-embed mx-4",attrs:{"data-id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }